import { Center, Text } from '@chakra-ui/react';
import { Handle, Position, NodeProps } from 'reactflow';

type NodeData = {
  label: string;
};

export function EndNode({ data, isConnectable }: NodeProps<NodeData>) {
  return (
    <>
      <Handle type="target" position={Position.Left} isConnectable={isConnectable} />
      <Center rounded="full" border="1px" p="3" bgColor="white" boxShadow="md">
        <Text fontSize="sm" color="gray.700">
          {data.label}
        </Text>
      </Center>
    </>
  );
}
